<script lang='ts'>
import { reactive, defineComponent, ref, onMounted, onUnmounted } from '@vue/composition-api';
import { isUrl } from '../utils/forms/validators';

interface IProps {
    myProp: boolean;
}

const AppFileDropzone = defineComponent({
    name: 'AppFileDropzone',
    props: { myProp: Boolean },
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    setup(props: IProps, ctx) {
        const state = reactive({});

        const active = ref(false);

        function setActive() {
            active.value = true;
        }
        function setInactive() {
            active.value = false;
        }

        function onDrop(e: any) {
            setInactive();
            ctx.emit('files-dropped', [...e.dataTransfer.files]);
        }

        function preventDefaults(e: any) {
            e.preventDefault();
        }

        const onPaste = (event: any) => {
            const files: File[] = [];
            const items = (event?.clipboardData || event.originalEvent?.clipboardData).items;
            for (const item of items) {
                if (item.kind == 'file') {
                    const file = item.getAsFile();
                    files.push(file);
                } else if (item.kind == 'string' && item.type == 'text/plain') {
                    item.getAsString((text: any) => {
                        if (isUrl()(text) === true) {
                            ctx.emit('link-pasted', text);
                        }
                    });
                }
            }

            if (files.length > 0) {
                ctx.emit('files-dropped', files);
            }
        };

        const events = ['dragenter', 'dragover', 'dragleave', 'drop'];

        onMounted(() => {
            events.forEach((eventName) => {
                document.body.addEventListener(eventName, preventDefaults);
            });
            document.body.addEventListener('paste', onPaste);
        });

        onUnmounted(() => {
            events.forEach((eventName) => {
                document.body.removeEventListener(eventName, preventDefaults);
            });
            document.body.removeEventListener('paste', onPaste);
        });

        return {
            state,
            active,
            setActive,
            setInactive,
            onDrop,
        };
    },
});

export default AppFileDropzone;
</script>

<template>
  <!-- add `data-active` and the event listeners -->
  <div
    :data-active="active"
    @dragenter.prevent="setActive"
    @dragover.prevent="setActive"
    @dragleave.prevent="setInactive"
    @drop.prevent="onDrop"
  >
    <!-- share state with the scoped slot -->
    <slot :dropZoneActive="active" />
  </div>
</template>

<style lang='scss' scoped></style>